module.exports = __webpack_public_path__ + "img/c&m_long_logo_white.c025c4eb.png";